import { proxy } from 'valtio';
import { enumParser, ENVIRONMENT } from '@soundxyz/utils/const';
import { PersistenceStorage } from '@store/persistence';
import type { ReleaseFilterStatusState } from './schema';
import { FeaturedStatusEnum, ReleaseFilterStatusSchema, ReleaseStatusEnum } from './schema';

const version = '0.1';
const storageKey = `@soundxyz/releaseFilterStatus${
  ENVIRONMENT === 'production' ? '' : '-' + ENVIRONMENT
}-${version}`;

export const ReleaseStatusPersistence = PersistenceStorage({
  schema: ReleaseFilterStatusSchema,
  key: storageKey,
  eager: true,
});

export const FeaturedStatusParser = enumParser(FeaturedStatusEnum.enum);
export const ReleaseStatusParser = enumParser(ReleaseStatusEnum.enum);

const initialReleaseStatusState = () =>
  ({
    recent: {
      featuredStatus: FeaturedStatusEnum.enum.All,
      releaseStatus: ReleaseStatusEnum.enum.All,
      scrollIndex: 0,
    },
    upcoming: {
      featuredStatus: FeaturedStatusEnum.enum.All,
      scrollIndex: 0,
    },
  }) satisfies ReleaseFilterStatusState;

export const releaseStatusState = proxy<ReleaseFilterStatusState>(initialReleaseStatusState());
